import { put, takeLatest, select } from 'redux-saga/effects';
import invariant from 'invariant';
import { booting as bootingMusic } from 'containers/MusicPage/actions';

import { store } from 'store';
import { getNavData as navDataSelector } from 'containers/Menu/selectors/navData.selector';
import { setNavData, navDataFetchingError } from '../actions';
import { LOAD_NAV_DATA } from '../constants';
import { getHasNodeMusicEnabled } from '../selectors';

function* fetchNavigation() {
  const state = store.getState();
  const nodes = navDataSelector(state);
  try {
    invariant(
      nodes.length !== 0,
      '(Navigation/saga...) fetchNavData: Service Error',
    );
    yield put(setNavData(nodes));
    const hasNodeMusic = yield select(getHasNodeMusicEnabled);
    if (hasNodeMusic) yield put(bootingMusic());
  } catch (error) {
    yield put(navDataFetchingError(error));
  }
}

export default function* navigationSaga() {
  yield takeLatest(LOAD_NAV_DATA.BOOT, fetchNavigation);
}
